const BASE_URL = "https://final-project-tick-info.herokuapp.com";

export const API_URL = (slug) => `${BASE_URL}/${slug}`;